import Cookie from 'js-cookie';
import { observable, computed } from 'mobx';

import {
  COOKIE_NAME,
  MAX_NOTIFICATION_PER_PAGE,
  NOTIFICATION_TYPE
} from './constants';

class NotificationStore {
  // #region setup
  constructor() {
    this.isPushDisabled =
      Cookie.get(COOKIE_NAME) === 'false' || !this.isSupported;
    this.isPushSubscribed =
      window.Notification && window.Notification.permission === 'granted';
  }

  @observable _notifications = [];
  @observable _unreadNotifications = [];
  @observable isPushDisabled = false;
  @observable isPushSubscribed = false;
  // #endregion

  // #region getters
  @computed
  get notifications() {
    return this._notifications.slice(0, MAX_NOTIFICATION_PER_PAGE);
  }

  set notifications(value) {
    this.setItems(value, NOTIFICATION_TYPE.NORMAL);
  }

  @computed
  get unreadNotifications() {
    return this._unreadNotifications;
  }

  set unreadNotifications(value) {
    this.setItems(value, NOTIFICATION_TYPE.UNREAD);
  }

  @computed
  get unreadNotificationsAmount() {
    return this.countFormatter(this._unreadNotifications.length);
  }

  @computed
  get isNotificationAuthorizeEnabled() {
    return !(this.isPushDisabled || this.isPushSubscribed);
  }
  // #endregion

  // #region setters
  setItems(value, type) {
    const array = `_${type}`;

    if (value instanceof Array) {
      this[array] = value;
    } else {
      this[array].unshift(value);
    }

    this[array] = this[array].sort((a, b) => this.orderByDate(a, b));
  }
  // #endregion

  // #region helpers
  countFormatter(size) {
    return MAX_NOTIFICATION_PER_PAGE >= size
      ? size
      : `${MAX_NOTIFICATION_PER_PAGE}+`;
  }

  get isSupported() {
    return (
      'serviceWorker' in navigator &&
      'PushManager' in window &&
      'Notification' in window &&
      window.Notification &&
      window.Notification.permission !== 'denied'
    );
  }

  orderByDate(a, b) {
    b = b.updatedDate || b.createDate;
    a = a.updatedDate || a.createDate;

    return new Date(b) - new Date(a);
  }
  // #endregion
}

export default new NotificationStore();
